import { template as template_ad06d24f125b4251a5f49095036dc1d7 } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { inputVal } from 'eflex/helpers';
import BsButton from 'eflex/components/bs-button';
export default template_ad06d24f125b4251a5f49095036dc1d7(`
<div class="link-input-wrapper input-group" ...attributes>
  <input
    class="form-control link-input"
    type="url"
    value={{@link}}
    disabled={{@disabled}}
    placeholder="https://"
    {{on "input" (inputVal @updateLink)}}
  />
  {{#if @previewLink}}
    <BsButton
      class="rounded rounded-start-0"
      @disabled={{@disabled}}
      @type="secondary"
      @onClick={{@previewLink}}
    >
      {{t "preview"}}
    </BsButton>
  {{/if}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
